import { RootAction, RootState } from '@src/app/_redux';
import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { clearSessionState } from '@src/app/_global/utility/persistedStorage';
import { USER_LOGOUT } from '@src/app/header/actions';
import { actionCreators as gaActionCreators } from '@src/app/analytics/googleAnalytics/actions';
import { actionCreators } from '@src/app/header/actions';
import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

export const clearAWSCreds = (
    action$: ActionsObservable<RootAction>,  
    state$: StateObservable<RootState>) =>
  action$.pipe(
    ofType(USER_LOGOUT),
    mergeMap(() => {
      // remove next line after adding complete persistence
      clearSessionState();
      gaActionCreators.createGAEvent({ category: 'Logout', action: 'Successful', label: state$.value.clientConfig.clientConfig.magCode, });
      actionCreators.userLogoutSuccessNotification();
      return of(actionCreators.userLogoutSuccess());
    }),
  );
